import * as actionTypes from './actionTypes';
import { Hardware } from 'api';
// import { INSERT_PORTFOLIO_TO_STORE } from './actionTypes';

export interface IHardwareStore {
    hardware: Hardware[],
    isLoading: boolean,
    isLoaded: boolean,
    saving: boolean,
    errorMsg?: string
}

export interface IAction {
    type: string, 
    payload:any
}

const initialState:IHardwareStore = {
    hardware: [],
    isLoading: false,
    isLoaded: false,
    saving: false,
    errorMsg: ""
}

const hardware = (state: IHardwareStore = initialState, action: IAction) => {
    switch (action.type) {
        case actionTypes.GET_HARDWARE:
            state = {
                ...state,
                isLoading: true
            }
            break;

        case actionTypes.GET_HARDWARE_SUCCESS:
            state = {
                ...state,
                hardware: action.payload,
                isLoading: false,
                isLoaded: true
            }
            break;

        /* case actionTypes.PORTFOLIO_API_ERROR:
            state = {
                ...state,
                errorMsg: action.payload
            }
            break;
        

        case actionTypes.PORTFOLIO_API_ERROR_CLEAR:
            state = {
                ...state,
                errorMsg: ""
            }
            break; */

        default:
            state = { ...state };
            break;
    }
    return state;
}

export default hardware;